import { Content, StyledDialog } from "./ConfirmationDialog.styles";
import { FC } from "react";
import DialogTitle from "../../Dialog/components/DialogTitle";
import { FooterActions } from "../../Dialog";

interface ConfirmationDialogProps {
	open: boolean;
	title: string;
	subtitle: string;
	cancelText: string;
	confirmText: string;
	onClose?: () => void;
	onCancel?: () => void;
	onConfirm?: () => void;
	onCancelConfirm?: () => void;
}

const ConfirmationDialog: FC<ConfirmationDialogProps> = ({
	open,
	subtitle,
	title,
	cancelText,
	confirmText,
	onClose,
	onCancel,
	onConfirm,
	onCancelConfirm
}) => {
	return (
		<StyledDialog
			open={open}
			data-testid="leave-flow-dialog"
			onClose={onClose ?? onCancel}
		>
			<DialogTitle
				title={title}
				handleClose={onClose ?? onCancel}
			/>
			<Content>
				<div>{subtitle}</div>
				<FooterActions
					handleClose={onCancelConfirm ?? onCancel ?? onClose}
					handleConfirm={onConfirm}
					cancelText={cancelText}
					confirmText={confirmText}
				/>
			</Content>
		</StyledDialog>
	);
};

export default ConfirmationDialog;
